import React from 'react'
import { StyleSheet, View, Image } from 'react-native'

const BottomLogo = props => {
    return (
        <View style={{...styles.imageContainer,...props.style}}>
                    <Image  resizeMode='contain' style={styles.image} source={require('../assets/afterlife-square.png')} />
        </View>
    )
}

export default BottomLogo

const styles = StyleSheet.create({
    imageContainer: {
        height: 65,
        width: 65
      },
      image: {
        height: '100%',
        width: '100%'
      }
})
